/* ZENHERO Produktseite (sections/zh-product.liquid): Variantenwahl, Preis, Menge, Kaufen, Galerie-Punkte, Sticky-Kaufleiste.
   Läuft zusätzlich zu application.js (nutzt nur PriceFormatter, reloadCart, openCartDrawer, getShopifyApiRoot, falls vorhanden). */
(function () {
    'use strict';

    function root() {
        return typeof window.getShopifyApiRoot === 'function' ? window.getShopifyApiRoot() : '/';
    }

    function formatMoney(cents) {
        if (window.PriceFormatter && typeof window.PriceFormatter.format === 'function') {
            return window.PriceFormatter.format(Math.trunc(cents));
        }
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function init(section) {
        if (!section || section.__zhInit) return;
        section.__zhInit = true;

        var variantsEl = section.querySelector('[data-zh-variants]');
        var form = section.querySelector('[data-zh-form]');
        if (!variantsEl || !form) return;

        var variants = [];
        try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }

        var idInput = form.querySelector('[data-zh-variant-id]');
        var atc = form.querySelector('[data-zh-atc]');
        var atcLabel = form.querySelector('[data-zh-atc-label]');
        var message = form.querySelector('[data-zh-message]');
        var qtyInput = form.querySelector('.zh-qty__input');
        var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-zh-option]'));
        var priceBox = section.querySelector('[data-zh-price]');
        var saving = section.querySelector('[data-zh-saving]');
        var savingValue = section.querySelector('[data-zh-saving-value]');
        var unit = section.querySelector('[data-zh-unit]');
        var sticky = section.querySelector('[data-zh-sticky]');
        var cartType = section.getAttribute('data-cart-type') || 'slider';
        var track = section.querySelector('[data-zh-gallery-track]');
        var dots = Array.prototype.slice.call(section.querySelectorAll('.zh-gallery__dot'));
        var countEl = section.querySelector('[data-zh-gallery-current]');
        var stockEl = section.querySelector('[data-zh-stock]');
        var galleryBox = section.querySelector('[data-zh-gallery]');
        var moreBtn = section.querySelector('[data-zh-gallery-more]');

        function selectedOptions() {
            return fieldsets.map(function (fs) {
                var checked = fs.querySelector('input:checked');
                return checked ? checked.value : null;
            });
        }

        function matches(variant, opts) {
            var keys = [variant.o1, variant.o2, variant.o3];
            for (var i = 0; i < opts.length; i++) {
                if (opts[i] !== null && keys[i] !== opts[i]) return false;
            }
            return true;
        }

        function currentVariant() {
            if (!fieldsets.length) return variants[0];
            var opts = selectedOptions();
            return variants.filter(function (v) { return matches(v, opts); })[0] || null;
        }

        function markAvailability() {
            var opts = selectedOptions();
            fieldsets.forEach(function (fs, index) {
                Array.prototype.forEach.call(fs.querySelectorAll('.zh-option__input'), function (input) {
                    var test = opts.slice();
                    test[index] = input.value;
                    var possible = variants.some(function (v) { return v.available && matches(v, test); });
                    var label = fs.querySelector('label[for="' + input.id + '"]');
                    if (label) label.classList.toggle('is-unavailable', !possible);
                });
            });
        }

        function setPrice(variant) {
            if (!priceBox) return;
            var priceEl = priceBox.querySelector('.price [data-price]');
            var compareEl = priceBox.querySelector('.price s');
            if (priceEl) {
                priceEl.setAttribute('data-price', variant.price);
                priceEl.textContent = formatMoney(variant.price);
            }
            if (compareEl) {
                var hasCompare = variant.compare > variant.price;
                compareEl.setAttribute('data-compare-price', hasCompare ? variant.compare : '');
                compareEl.textContent = hasCompare ? formatMoney(variant.compare) : '';
            }
            if (saving) {
                var onSale = variant.compare > variant.price;
                saving.hidden = !onSale;
                if (savingValue && onSale) savingValue.textContent = Math.floor((variant.compare - variant.price) * 100 / variant.compare) + '%';
            }
            if (unit) {
                if (variant.unit) {
                    unit.hidden = false;
                    unit.textContent = variant.unit + ' / ' + variant.unit_ref;
                } else {
                    unit.hidden = true;
                    unit.textContent = '';
                }
            }
        }

        function setAvailability(variant) {
            var text = variant.available ? atc.getAttribute('data-text-add') : atc.getAttribute('data-text-sold');
            atc.disabled = !variant.available;
            if (atcLabel) atcLabel.textContent = text;
            if (sticky) {
                var sb = sticky.querySelector('[data-zh-sticky-atc]');
                var sl = sticky.querySelector('[data-zh-sticky-label]');
                if (sb) sb.disabled = !variant.available;
                if (sl) sl.textContent = text;
            }
        }

        /* Verfügbarkeit: nur Daten aus dem Shop (stock = in | avail | out, qty = verfolgter Bestand) */
        function updateStock(variant) {
            if (!stockEl) return;
            var state = variant.stock || (variant.available ? 'avail' : 'out');
            var text = stockEl.getAttribute('data-text-' + state) || '';
            var low = parseInt(stockEl.getAttribute('data-low'), 10) || 0;
            if (state === 'in' && low > 0 && variant.qty > 0 && variant.qty <= low) {
                text = (stockEl.getAttribute('data-text-low') || text).replace('__COUNT__', variant.qty);
            }
            stockEl.setAttribute('data-state', state);
            var label = stockEl.querySelector('[data-zh-stock-text]');
            if (label) label.textContent = text;
            var delivery = stockEl.querySelector('[data-zh-stock-delivery]');
            if (delivery) delivery.hidden = state === 'out';
        }

        function syncSticky(variant) {
            if (!sticky) return;
            var v = sticky.querySelector('[data-zh-sticky-variant]');
            var p = sticky.querySelector('[data-zh-sticky-price] [data-price]');
            if (v && fieldsets.length) v.textContent = variant.title;
            if (p) p.textContent = formatMoney(variant.price);
        }

        function showMedia(variant) {
            if (!track || !variant.media) return;
            var item = track.querySelector('[data-media-id="' + variant.media + '"]');
            if (!item) return;
            if (track.scrollWidth > track.clientWidth + 2) {
                track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
            } else {
                var rect = item.getBoundingClientRect();
                if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
                    item.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        }

        function onChange(initial) {
            var variant = currentVariant();
            fieldsets.forEach(function (fs) {
                var checked = fs.querySelector('input:checked');
                var cur = fs.querySelector('[data-zh-option-current]');
                if (cur && checked) cur.textContent = checked.value;
            });
            markAvailability();
            if (!variant) {
                atc.disabled = true;
                if (atcLabel) atcLabel.textContent = atc.getAttribute('data-text-sold');
                return;
            }
            idInput.value = variant.id;
            setAvailability(variant);
            /* Beim Laden bleibt der serverseitig gerenderte Preis stehen (PriceFormatter aus application.js ist dann evtl. noch nicht konfiguriert). */
            if (initial !== true) {
                setPrice(variant);
                updateStock(variant);
                syncSticky(variant);
                showMedia(variant);
                if (window.history && window.history.replaceState) {
                    var url = new URL(window.location.href);
                    url.searchParams.set('variant', variant.id);
                    window.history.replaceState(null, '', url.toString());
                }
            }
        }

        fieldsets.forEach(function (fs) {
            fs.addEventListener('change', function () { onChange(false); });
        });

        /* Menge */
        var qtyBox = form.querySelector('[data-zh-qty]');
        if (qtyBox && qtyInput) {
            qtyBox.addEventListener('click', function (event) {
                var minus = event.target.closest('[data-zh-qty-minus]');
                var plus = event.target.closest('[data-zh-qty-plus]');
                var value = parseInt(qtyInput.value, 10) || 1;
                if (minus) value = Math.max(1, value - 1);
                if (plus) value = value + 1;
                if (minus || plus) qtyInput.value = value;
            });
            qtyInput.addEventListener('change', function () {
                var value = parseInt(qtyInput.value, 10);
                qtyInput.value = isNaN(value) || value < 1 ? 1 : value;
            });
        }

        /* Kaufen */
        function showError(text) {
            if (!message) return;
            message.textContent = text;
            message.hidden = !text;
        }

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (atc.disabled || section.classList.contains('is-loading')) return;
            showError('');
            section.classList.add('is-loading');

            var payload = { id: parseInt(idInput.value, 10), quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1 };

            fetch(root() + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(payload)
            }).then(function (response) {
                return response.json().then(function (data) { return { ok: response.ok, data: data }; });
            }).then(function (result) {
                if (!result.ok) {
                    section.classList.remove('is-loading');
                    showError(result.data && (result.data.description || result.data.message) ? (result.data.description || result.data.message) : '');
                    return;
                }
                if (cartType === 'page' || typeof window.reloadCart !== 'function') {
                    window.location.href = root() + 'cart';
                    return;
                }
                window.reloadCart(function () {
                    section.classList.remove('is-loading');
                    if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
                });
            }).catch(function () {
                section.classList.remove('is-loading');
                showError(document.documentElement.lang && document.documentElement.lang.indexOf('de') === 0
                    ? 'Es ist ein Fehler aufgetreten. Bitte versuche es noch einmal.'
                    : 'An error has occurred. Please try again.');
            });
        });

        /* Sticky-Kaufleiste */
        if (sticky && atc && 'IntersectionObserver' in window) {
            var stickyBtn = sticky.querySelector('[data-zh-sticky-atc]');
            if (stickyBtn) {
                stickyBtn.addEventListener('click', function () {
                    if (typeof form.requestSubmit === 'function') form.requestSubmit();
                    else form.dispatchEvent(new Event('submit', { cancelable: true }));
                });
            }
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    /* sichtbar, sobald der Hauptbutton nicht im Bild ist (mobil also schon beim Laden, wenn er unter dem Bildschirmrand liegt) */
                    var show = !entry.isIntersecting;
                    sticky.hidden = !show;
                    document.documentElement.classList.toggle('zh-has-sticky', show);
                });
            }, { threshold: 0 });
            observer.observe(atc);
        }

        /* Galerie-Punkte (Mobil) */
        if (track && dots.length > 1) {
            var ticking = false;
            track.addEventListener('scroll', function () {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(function () {
                    ticking = false;
                    var first = track.firstElementChild;
                    var step = first ? first.getBoundingClientRect().width : track.clientWidth;
                    var index = Math.round(track.scrollLeft / Math.max(step, 1));
                    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
                    if (countEl) countEl.textContent = index + 1;
                });
            }, { passive: true });
        }

        if (moreBtn && galleryBox) {
            moreBtn.addEventListener('click', function () {
                var open = !galleryBox.classList.contains('is-expanded');
                galleryBox.classList.toggle('is-expanded', open);
                moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
                var label = moreBtn.querySelector('[data-zh-gallery-more-label]');
                if (label) label.textContent = moreBtn.getAttribute(open ? 'data-text-less' : 'data-text-more');
            });
        }

        onChange(true);
    }

    function boot() {
        Array.prototype.forEach.call(document.querySelectorAll('[data-zh-pdp]'), init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', function (event) {
        var section = event.target && event.target.querySelector ? event.target.querySelector('[data-zh-pdp]') : null;
        if (section) init(section);
    });
})();
